import React from 'react'
import { useAppSelector, useAppDispatch } from '../store/store'
import { useSigninSubmit } from '../hooks/useAuthActions'
import { AuthMethodOptions, contextSigninSubmit } from '../types.d'
import { InjectedAuthProps, withAuthProps } from './withAuthProps'
import { toggleSigninTermsAgreement } from '../store'

export type InjectedSigninMethodProps = {
  onSubmit: contextSigninSubmit
  authMethod: AuthMethodOptions
  requiresTermsAgreement: boolean
  termsAgreed: boolean
  onTermsAgreementChange: (agreed: boolean) => void
} & InjectedAuthProps

export function withSigninMethodProps<P>(
  WrappedComponent: React.ComponentType<P>,
) {
  const WithAuth = withAuthProps(WrappedComponent)

  return function WithSignInMethodProps(
    props: Omit<P, keyof InjectedSigninMethodProps>,
  ) {
    const dispatch = useAppDispatch()
    const signinSubmit = useSigninSubmit()
    const authMethod = useAppSelector((state) => state.auth.signin?.authMethod)
    const requiresTermsAgreement = useAppSelector(
      (state) => state.auth.signin?.userInfo?.requiresTermsAgreement || false,
    )
    const termsAgreed = useAppSelector(
      (state) => state.auth.signin?.termsAgreed || false,
    )

    const extraAuthProps = {
      onSubmit: signinSubmit,
      authMethod,
      requiresTermsAgreement,
      termsAgreed,
      onTermsAgreementChange: (agreed: boolean) => {
        dispatch(toggleSigninTermsAgreement(agreed))
      },
    }

    return <WithAuth {...(props as P)} {...extraAuthProps} />
  }
}
